// Install the angularjs.TypeScript.DefinitelyTyped NuGet package
namespace Cfnc {
    "use strict";

    interface ICfncAddress extends angular.IDirective {
        templateUrl: string;
    }

    interface ICfncAddressScope extends angular.IScope {
        ngModel: any;
        ncCounties: Array<IAddressListItem>;
        states: Array<IAddressListItem>;
        countries: Array<IAddressListItem>;
        addressType: string;
        showSameAsAbove: boolean;
        sameAsAbove: boolean;
        copyFrom: Address;
        common: ICommonFactory;
        disableCounty: boolean;
        disableCountry: boolean;

        stateChanged: (oldValue, newValue) => void;
        countryChanged: (oldValue) => void;
        copyFromAbove: () => void;
    }

    interface ICfncAddressAttributes extends angular.IAttributes {
        firstName: string;
        lastName: string;
        addressType: string;
        copyFrom: string;
        disableCounty: string;
        disableCountry: string;
    }

    class Address implements IAddress {
        addressType: string;
        firstName: string;
        lastName: string;
        street: string;
        street2: string;
        city: string;
        state: string;
        postalCode: string;
        country: string
        county: string;
        isVerified: boolean;
        resultCodes: string;
        userOverride: boolean;
        signature: string;
        key: string;
    }

    CfncAddress.$inject = ["addressService", "common"];

    function CfncAddress(addressService: IAddressService, common: ICommonFactory): ICfncAddress {

        // Usage:
        //     <cfnc-address copy-from="Address"></cfnc-address>
        // Creates:
        // 

        return {
            restrict: "EA",
            require: "ngModel",
            link: link,
            templateUrl: "/app/directives/cfncAddress/cfncAddress.html",
            scope: {
                ngModel: "=",
                copyFrom: "="
            }

        }

        function link(scope: ICfncAddressScope, element: angular.IAugmentedJQuery, attrs: ICfncAddressAttributes) {
            scope.common = common;
            scope.ncCounties = addressService.ncCountyList;
            scope.states = addressService.stateList;
            scope.countries = addressService.countryList;
            scope.addressType = attrs.addressType;
            scope.showSameAsAbove = attrs.copyFrom ? true : false;
            scope.sameAsAbove = false;

            scope.disableCounty = attrs.disableCounty ? true : false;
            scope.disableCountry = attrs.disableCountry ? true : false;

            scope.stateChanged = function stateChanged(oldValue, newValue) {
                if (oldValue === "NC" || newValue === "NC") {
                    scope.ngModel.county = null;
                }
            }

            scope.countryChanged = function countryChanged(oldValue) {
                if (oldValue == "US") {
                    scope.ngModel.county = null;
                }
            }

            scope.$watch("copyFrom", (newValue, oldValue, originalScope) => {
                if (scope.sameAsAbove) {
                    console.log("inside the debounce");
                    var addressType = scope.ngModel.addressType;
                    copyAddress(scope.copyFrom, scope.ngModel);
                    scope.ngModel.addressType = addressType;
                }
            }, true);

            scope.$watch("sameAsAbove", (newValue, oldValue, originalScope) => {
                if (newValue) {
                    var addressType = scope.ngModel.addressType;
                    copyAddress(scope.copyFrom, scope.ngModel);
                    scope.ngModel.addressType = addressType;
                }
                scope.$applyAsync();
            });
        }

        function copyAddress(source: Address, destination: Address) {
            destination.street = source.street;
            destination.street2 = source.street2;
            destination.city = source.city;
            destination.state = source.state;
            destination.postalCode = source.postalCode;
            destination.country = source.country;
            destination.county = source.county;
        };

    }

    angular.module("app").directive("cfncAddress", CfncAddress);
}